import { Button } from "../ui/button"

export function TabOption({ value, label, onClick, selected }) {
  const ativo = selected === value
  return (
    <Button
      onClick={() => onClick(value)}
      variant={ativo ? "destructive" : "secondary"}
      className="cursor-pointer">
      {label}
    </Button>
  )
}